import { mount } from 'svelte';
import Avatar from './components/Avatar.svelte';

export default class Sveltes {
    init() {
        let avatar = document.getElementById('avatar');
        if (avatar) {
            const app = mount(Avatar, {
                target: avatar,
                props: {
                    img_url: avatar.getAttribute('data-img-url'),
                }
            });
        }
    }
}
